"use strict";

import angular from "angular";

import { User } from "../../../gateway/User/User";
import { ToastAdapter } from "../../../presentation/adpters/ToastAdapter/ToastAdapter";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import "./dialog-change-password.scss";

class DialogChangePasswordCtrl {
    User = new User();
    user = new UserDataAdapter().user();
    loading = false;
    constructor($rootScope, $mdToast, $mdDialog, locals) {
        this.Toast = new ToastAdapter({ Toast: $mdToast });
        this.$mdDialog = $mdDialog;
        this.$rootScope = $rootScope;
        this.locals = locals;
    }
    $onInit() {
        this.oldPwdShow = false;
        this.pwdShow = false;
        this.newPwdShow = false;
    }
    cancel() {
        this.$mdDialog.cancel();
        this._onCleanForm();
    }
    onChangePassword = async () => {
        this.loading = true;
        try {
            await this.User.setPassword(
                this.user._id,
                this.document.data.password
            );
            this.$rootScope.$broadcast(
                "SET_NANDA_NOTIFICATION",
                "PASSWORD_UPDATE_SUCCESS"
            );
            this.$mdDialog.hide();
        } catch (err) {
            this.$rootScope.$broadcast(
                "SET_NANDA_NOTIFICATION",
                "GENERIC_ERROR"
            );
        } finally {
            this.loading = false;
        }
        setTimeout(() => {
            this.$rootScope.$broadcast("SET_NANDA_NOTIFICATION", "CLEAR");
        }, 3000);
        this._onCleanForm();
    };
    _onCleanForm() {
        this.document = { data: {} };
        if (this.form) {
            this.form.$setPristine();
            this.form.$setUntouched();
        }
    }
    onShowPassword = (elementId) => {
        if (!elementId) return;
        const element = angular.element(document.getElementById(elementId))[0];
        element.type === "password"
            ? (element.type = "text")
            : (element.type = "password");
    };
}

angular.module("nucont.shared").controller("DialogChangePasswordCtrl", [
    "$rootScope",
    "$mdToast",
    "$mdDialog",
    "locals",
    DialogChangePasswordCtrl
]);
